import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { omit } from 'lodash';
import ContentModule from './content_module';
import {
  MODULE_TYPE_FEED,
  MODULE_TYPE_HP_REFRESH_FEATURED_STORY,
  MODULE_TYPE_HP_REFRESH_FEED,
  MODULE_TYPE_HP_REFRESH_FEED_ADS,
  MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY,
  MODULE_TYPE_HP_REFRESH_MOST_POPULAR,
  MODULE_TYPE_HP_REFRESH_TRENDING_VIDEOS,
  MODULE_TYPE_SHOPS_CATEGORY
} from './mobile_content_module';
import PageHeaderModule from './page_header_module';
import MediaQuery from '../common/media_query';
import { CONTRIBUTOR_PAGE_TYPE } from '../../constants';
import { isHomepageRefresh } from '../../utils/homepage_refresh/homepage';

const PAGE_HEADER_MODULE_TYPE = 'page-header';
const TRENDING_ON_R29_MODULE_TYPE = 'content';
export const FEED_MODULE_ROW_COUNT = 14;

const Module = (props, { location, edition_data }) => {
  // This is used in spec/feature/error.feature
  if (process.env.NODE_ENV !== 'production' && props.type === 'bad-module') {
    throw new Error('Manually triggered React rendering error!');
  }

  const onContributorPage = props.page_type === CONTRIBUTOR_PAGE_TYPE;
  const isRefresh = isHomepageRefresh(location, edition_data, true);

  const breakpointContentModule = (breakpoint) => (
    <MediaQuery breakpoint={breakpoint}>
      <ContentModule {...props} />
    </MediaQuery>
  );

  /*
   * This function handles the rendering of feed modules when isRefresh
   * is true (We are on the homepage refresh at any breakpoint). For
   * not-mobile, the feed module renders as expected. On mobile, we only
   * render any rows returned from the "More Stories" click.
   */
  const getRefreshFeedModule = () => {
    const refreshFeedRows = props.rows.slice(FEED_MODULE_ROW_COUNT, props.rows.length);
    const refreshFeedMoreStoriesRows = !!refreshFeedRows.length && (
      <MediaQuery breakpoint="mobile">
        <ContentModule {...props} rows={refreshFeedRows} title="" />
      </MediaQuery>
    );

    return (
      <Fragment>
        {refreshFeedMoreStoriesRows}
        {breakpointContentModule('notMobile')}
      </Fragment>
    );
  };

  switch (props.type) {
    case PAGE_HEADER_MODULE_TYPE:
      return onContributorPage && <PageHeaderModule {...props} />;
    case MODULE_TYPE_FEED:
      return isRefresh ? getRefreshFeedModule() : <ContentModule {...props} />;
    case MODULE_TYPE_SHOPS_CATEGORY:
    case TRENDING_ON_R29_MODULE_TYPE:
      return isRefresh ? breakpointContentModule('notMobile') : <ContentModule {...props} />;
    case MODULE_TYPE_HP_REFRESH_FEED:
    case MODULE_TYPE_HP_REFRESH_FEED_ADS:
    case MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY:
    case MODULE_TYPE_HP_REFRESH_FEATURED_STORY:
    case MODULE_TYPE_HP_REFRESH_TRENDING_VIDEOS:
    case MODULE_TYPE_HP_REFRESH_MOST_POPULAR:
      return isRefresh ? breakpointContentModule('mobile') : null;
    default:
      return <ContentModule {...props} />;
  }
};

Module.propTypes = {
  type: PropTypes.string.isRequired,
  page_type: PropTypes.string,
  page_id: PropTypes.number,
  rows: PropTypes.arrayOf(PropTypes.object),
  pagination: PropTypes.object,
  title: PropTypes.string
};

Module.contextTypes = {
  location: PropTypes.object,
  edition_data: PropTypes.object
};

export default Module;
